<template>
  <div class="main first-notify">
    <my-header title="消息通知"></my-header>
    <div class="container">
      <ul class="tab">
          <li class="switch">
              <span :class="{'active': type === 0, 'notice-red': !isOdds}" @click="tabSwitch(0)">异常</span>
              <span :class="{'active': type === 1, 'notice-red': !isNotices}" @click="tabSwitch(1)">通知</span>
          </li>
          <li class="features">
              <span @click="makedRead(1)">全部已读</span>
              <span @click="makedRead(0)">清空所有</span>
          </li>
      </ul >
      <div class="notify">
          <div class="has-list" v-if="notice.data && notice.data.length">
            <dl class="notice-list" :class="{'isnotice': type}" :state="item.isRead" @click="goDetail(item._id, item.isRead, item)" v-for="(item, index) in notice.data" :key="index">
                <dd>{{!type ? '[监控室-'+ item.nodeName +'] 已断电...' : '[设备-'+item.nodeName+'] 已上线...'}}</dd>
                <dd>{{comm.dateFormat(item.createdAt, 'yyyy-MM-dd HH:mm:ss')}}</dd>
            </dl>
            <div class="page">
                <el-pagination
                    background
                    prev-text="上一页"
                    next-text="下一页"
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="1"
                    @current-change="pageChange">
                </el-pagination>
            </div>
          </div>
          <dl class="no-list" v-else>
              <p>当前暂无信息</p>
          </dl>
      </div>
    </div>
  </div>
</template>
<script>
import MyHeader from '@/components/HeaderTitle'
import comm from '@/assets/lib/comm'
import cache from '@/assets/lib/cache'
import basic from '@/model/zone'
import { mapState } from 'vuex'
import notice from '../../model/notice'
import { Message } from 'element-ui'

export default {
  name: 'Notice',
  data () {
    return {
      isWeek: true,
      comm: comm,
      type: Number(this.noticeType), // 0： 异常 1： 通知
      where: {
        zoneId: '',
        page: 1,
        perPage: 5,
        deviceType: '',
        type: this.type
      },
      notice: {},
      isOdds: false,
      isNotices: false
    }
  },
  props: {
    noticeType: {
      type: String,
      default: '0'
    }
  },
  computed: {
    ...mapState(['zone']),
    total () {
      return this.notice.total ? Math.ceil(this.notice.total / this.where.perPage) : '1'
    }
  },
  components: {
    MyHeader
  },
  async mounted () {
    await this.info()
    this.where.zoneId = this.zone.id
    this.getNotice()
    this.getStatus()
  },
  methods: {
    // 获取初始信息
    async info () {
      if (!this.zone) {
        await basic.getBasicInfo()
      }
    },
    // 处理是否有未读通知红点标识
    async getStatus () {
      let temp = Object.assign({}, this.where)
      temp.perPage = ''
      temp.type = 0
      // 异常
      let odd = await notice.getNotice({ ...temp })
      // 通知
      temp.type = 1
      let notic = await notice.getNotice({ ...temp })
      this.isOdds = odd.data && odd.data.some(item => !item.isRead)
      this.isNotices = notic.data && notic.data.some(item => !item.isRead)
    },
    // 获取通知信息
    async getNotice () {
      this.where.type = this.type
      this.notice = await notice.getNotice({ ...this.where })
    },
    // 处理设置已读和清空
    async makedRead (type) {
      let params = {
        zoneId: this.zone.id,
        type: this.type
      }
      let result = type ? await notice.markedRead({ ...params }) : await notice.remove({ ...params })
      if (result.code === 1) {
        Message.success(`${type ? '已读设置成功！' : '清空成功！'}`)
        this.getStatus()
        this.getNotice()
      }
    },
    async goDetail (noticeId, isRead, items) {
      // 处理设置已读
      if (!isRead) {
        await notice.markedRead({ noticeId, type: this.type })
      }
      // 防止刷新采取storage
      cache.setCache('noticeContent', items)
      this.$router.push({
        name: 'noticeDetail',
        params: {
          id: noticeId,
          content: items
        },
        query: {
          type: this.type
        }
      })
    },
    // 页码变化
    pageChange (val) {
      this.where.page = val
      this.getNotice()
    },
    // 切换tab
    tabSwitch (type) {
      this.type = type
      this.reset()
      this.getNotice()
    },
    reset () {
      this.where.page = 1
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/base";
// 红点
.red {
    display: inline-block;
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #F16C69
}
.first-notify {
  .container {
    margin: 65px 20px 20px 20px;
    background-color: white;
    box-shadow: 0px 3px 10px 1px rgba(56, 126, 232, 0.1);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    height: 100%;
    .tab {
        height: 50px;
        line-height: 50px;
        border: 1px solid #EEEFF0;
        text-align: center;
        padding-left:  30px;
        padding-right: 24px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        box-sizing: border-box;
        .switch{
            width: 196px;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            box-sizing: border-box;
            span {
                font-size: 18px;
                box-sizing: border-box;
                color: #262626;
                font-weight: 600;
                flex: 1;
                &:after {
                    .red;
                    position: relative;
                    top: -10px;
                    left: 4px;
                }
            }
            .active {
                color: #39D474;
                border-bottom: 1px solid #39D474;
            }
            .notice-red {
              &:after {
                background: #fff;
              }
            }
        }
        .features {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            span {
                font-size: 14px;
                color: #595959;
                text-decoration:underline;
                &:first-child{
                    margin-right: 24px;
                    &:before {
                        position: relative;
                        top: 3px;
                        display: inline-block;
                        content: '';
                        width: 14px;
                        height:14px;
                        background: url("../../assets/images/home/inf-haveread.png") no-repeat;
                        background-size: cover;
                        margin-right: 2px;
                    }
                }
                &:last-child{
                    &:before {
                        position: relative;
                        top: 3px;
                        display: inline-block;
                        content: '';
                        width: 14px;
                        height:14px;
                        background: url("../../assets/images/home/inf-clear.png") no-repeat;
                        background-size: cover;
                        margin-right: 2px;
                    }
                }
            }
        }
    }
    .notify {
        padding-left: 30px;
        padding-right: 24px;
        .notice-list {
            display: flex;
            flex-flow: row nowrap;
            padding: 15px 0;
            justify-content: space-between;
            border-bottom: 1px solid #EEEFF0;
            dd {
                display: flex;
                align-items: center;
                &:first-child{
                    font-size: 15px;
                    color:#595959;
                    &:before{
                        display: inline-block;
                        content: '';
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        background: url("../../assets/images/home/inf-unusual.png") no-repeat;
                        background-size: cover;
                        margin-right: 16px;
                    }
                }
                &:last-child{
                    font-size: 14px;
                    color:#989898;
                    &:after{
                        .red;
                        margin-left: 12px;
                    }
                }
            }
            &[state="1"] {
                dd {
                     &:first-child{
                        color:#989898;
                        &:before{
                            opacity: .25;
                        }
                    }
                    &:last-child{
                        color:#ACACAC;
                        &:after{
                            background: #fff;
                        }
                    }
                }
            }
        }
        .isnotice {
          dd {
               &:first-child{
                    &:before {
                        background: url("../../assets/images/home/inf-notice.png") no-repeat;
                        background-size: cover;
                    }
               }
            }
        }
    }
    .page {
        position: absolute;
        bottom: 50px;
        width:100%;
        height: 30px;
        text-align: center;
        .btn-next, .btn-prev{
            width: 70px;
            height: 30px;
        }
        .number {
            height: 30px;
            line-height: 30px;
        }
    }
    .no-list {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        flex-flow: column nowrap;
        height: 400px;
        &:before{
            display: block;
            content: '';
            width: 77px;
            height: 77px;
            background: url("../../assets/images/home/inf-emptystates.png") no-repeat;
            background-size: cover;
        }
        p{
            font-size: 14px;
            color: #989898;
            margin-top: 16px;
        }
    }
  }
}
</style>
